<template>
  <div class="gestion">
    <h1>Gestion de vos articles</h1>
    <div class="body-article">
      <router-link to="/cms-create" class="link-to-create" >Créer un article</router-link>
      <ul class="list">

        <li v-for="article in articles" :key="article.Id" class="card">
          <div class="card-object">
            <div class="overlay">
              <div class="button-area">
                <button @click="viewArticle(article)">Visualiser</button>
              </div>
              <div class="body-card">
                <div class="management">

                  <router-link title="Voir l'article" class="btn tbl" :to="'/article/' + article.Id" target="_blank" rel="noreferrer"><font-awesome-icon icon="table" class="icon-table"></font-awesome-icon></router-link>
                  <button title="Editer l'article" class="edit" @click="updateArticle(article)"><font-awesome-icon icon="edit" class="icon-edit"></font-awesome-icon></button>
                  <button title="Supprimer l'article" class="trash" @click="deleteModal(article)"><font-awesome-icon icon="trash" class="icon-trash"></font-awesome-icon></button>
                </div>
              </div>
            </div>
            <div class="header">
              <span class="title">{{article.Titre}}</span>
            </div>
            <div class="body-card-under">
              <span>{{article.CategoryName}}</span>

            </div>
            <div class="footer">
              <div class="left">
                <font-awesome-icon icon="calendar-alt" class="icon-calendrier"></font-awesome-icon>
                <span class="date">
                  {{formatDate(article.CreationDate)}}
                </span>
              </div>
              <div class="right">
                <div class="online-indicator" v-if="article.IsVisible">
                  <span class="blink"></span>
                </div>

                <div class="offline-indicator" v-else>
                  <span class="blink-offline"></span>
                </div>
                <span class="offline-text">{{article.IsVisible ? 'En ligne' : 'Hors ligne'}}</span>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <Transition>
        <div v-if="preview">
          <CmsPreview :corps="selectedArticle.Corps" :titre="selectedArticle.Titre" @close="close"></CmsPreview>
        </div>
      </Transition>
      <div v-if="isDeleting">
        <CmsDeleteArticle :titre="selectedArticle.Titre" @close="cancelDelete" @deleteArticle="deleteArticle"></CmsDeleteArticle>
      </div>
      <div v-if="isUpdating">
        <CmsUpdateArticle :article="selectedArticle" @close="cancelUpdate" @updateArticleVue="updateArticleVue"></CmsUpdateArticle>
      </div>
    </div>
   </div>
</template>

<script>
  import { getMyArticles, deleteArticle } from "@/utils/cms" //Fonction pour récupérer les articles et en supprimer un
  import CmsPreview from "@/components/Cms/CmsPreview";
  import CmsDeleteArticle from "@/components/Cms/CmsDeleteArticle";
  import CmsUpdateArticle from "@/components/Cms/CmsUpdateArticle";
  export default {
    name: "CmsGestion",
    components: {
      CmsPreview,
      CmsDeleteArticle,
      CmsUpdateArticle
    },
    data() {
      return {
        articles: [], //LIste des articles
        selectedArticle: null, //Article sélectionné 
        preview: false, //L'utilisateur preview l'article
        isDeleting: false,//L'utilisateur supprime l'article
        isUpdating: false//L'utilisateur modifie l'article
      }

    },
    mounted() {
      getMyArticles().then((response) => {//récupère la liste des articles d'un user
        this.articles = response;
      })
    },
    methods: {
      formatDate: function (dt) { //Met en forme la date
        const date = new Date(dt);
        var hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
        var min = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
        var month = date.getMonth() + 1 < 10 ? '0' + date.getMonth() : date.getMonth();
        var day = date.getDate() + 1 < 10 ? '0' + date.getDate() : date.getDate();
        return (day + '/' + month + '/' + date.getFullYear() + ' ' + hour + ':' + min)
      },
      viewArticle(art) { //Montre le modal de preview d'un article
        this.selectedArticle = art;
        this.preview = true;
      },
      close() {
        this.preview = false; //Ferme la preview
        this.selectedArticle = null;
      },
      cancelDelete() { //L'utilisateur clique sur annuler quand il est entrain de supprimer
        this.isDeleting = false;
      },
      deleteModal: function (art) { //Affiche le modal de suppression
        this.selectedArticle = art;
        this.isDeleting = true;
      },
      updateArticle: function (art) { //Affiche le modal de modification
        this.selectedArticle = art;
        this.isUpdating = true;
      },
      deleteArticle: function () { //Supprime un article sélectionné
        const index = this.articles.findIndex(a => a.Id == this.selectedArticle.Id);
        if (index !== -1)
            this.articles.splice(index, 1);

        deleteArticle(this.selectedArticle.Id) //Supprime en bdd
        this.selectedArticle = null;
        this.isDeleting = false;
      },

      cancelUpdate: function () { //Annule les modification (fermeture du modal de modif)
        this.isUpdating = false;
        this.selectedArticle = null;
      },

      updateArticleVue: function (tempObject) { //Met à jour un article (visuellement)
        for (var i = 0; i < this.articles.length; i++) {
          if (this.articles[i].Id === this.selectedArticle.Id) {
            this.articles[i] = tempObject;
            break;
          }
        }
      }
    }
  }
</script>

<style scoped>
  .link-to-create {
      font-size: 20px;
      text-decoration: none;
  }
  .link-to-create:hover{
      text-decoration: underline;
  }
  .gestion {
    max-height: 100%;
    overflow: auto;
  }
  /*Structure de la carte*/
  .card-object {
      height: 100%;
      width: 100%;

  }

  .body-article {
    max-width:100%;
  }
  .list li{
      float:left;
      margin-left: 5%;
  }
  .gestion{
      width: 100%;
      height: 100%;
  }
  .card {
    width: 300px;
    height: 200px;
    background: none;
    border: 1px solid #dcdfe6;
    background: linear-gradient(#f4f5f8,#f1f3f6);
    margin-top: 2%;
  }
  .card .header{
      width:100%;
      height:40%;
      display:flex;
      align-items:center;
      justify-content:center;
      text-align:center;
      padding:10px;

  }
  .card .header .title{
      font-weight: bold;


  }

    .card .body-card-under {
      height: 40%;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

    }
      .card .body-card-under span {
        padding: 10px;
        background-color: #198754;
        color: white;
        word-break: break-word;
      }
    .card .footer {
      width: 100%;
      height: 20%;
      display: flex;
      align-items: center;


    }
      .card .footer .left {
        width: 50%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content:center;
      }
      .card .footer .right {
        width: 50%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .card .footer .left span {
        padding-left: 5%;
        color: rgba(0,0,0,.8);
        font-size: 14px;
      }
      .icon-calendrier{
          color: rgba(0,0,0,.5);
      }



  /*Gestion de l'overlay*/
  .overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0,0,0,0.6);
    overflow:hidden;
    width: 100%;
    height: 0;
    transition: .5s ease;
  }
  .card-object:hover .overlay {
    height: 100%;
    display: inline-block;
  }

  /*Bouton sur l'overlay (Visualiser) */
  .overlay .button-area{
      height: 60%;
      width: 100%;
      display:flex;
      justify-content:center;
      align-items:center;
      padding:10px;
  }
    .overlay .button-area button {
      border: 3px solid white;
      padding: 10px 15px;
      background: none;
      text-transform: uppercase;
      font-weight: bold;
      color: white;
      cursor: pointer;
      transition: .3s;
    }
      .overlay .button-area button:hover {
        background: #198754;
        border: 0px solid white;
        color: white;
      }



/*Statut en ligne / hors ligne : */
  div.online-indicator {
    display: inline-block;
    width: 15px;
    height: 15px;
    margin-right: 10px;
    background-color: #0fcc45;
    border-radius: 50%;
    position: relative;
    opacity: 1;
    transition: opacity .4s ease-out;
  }

  .card-object:hover div.online-indicator, .card-object:hover div.offline-indicator {
    opacity: 0;
  }

  div.offline-indicator {
    display: inline-block;
    width: 15px;
    height: 15px;
    margin-right: 10px;
    background-color: #FF5252;
    border-radius: 50%;
    position: relative;
    opacity: 1;
    transition: opacity .4s ease-out;
  }

  span.blink {
    display: block;
    width: 15px;
    height: 15px;
    background-color: #0fcc45;
    opacity: 0.7;
    border-radius: 50%;
    animation: blink 1s linear infinite;
  }

  span.blink-offline {
    display: block;
    width: 15px;
    height: 15px;
    background-color: #FF5252;
    opacity: 0.7;
    border-radius: 50%;
  }

  @keyframes blink {
    100% {
      transform: scale(2, 2);
      opacity: 0;
    }
  }


  /*Bouttons et menu de gestion*/

  .tbl {
    background-color: #28a745;
    border-color: #28a745;
    color: white;
  }

  .edit {
    background-color: #007bff;
    border-color: #007bff;
  }

  .trash {
    background-color: #dc3545;
    border-color: #dc3545;
  }

  .management {
    height: 100%;
    width: 100%;
    justify-content: space-around;
    align-items: center;
    display: flex;
    background: white;
    z-index: 1;
  }

    .management button, .management a {
      color: #fff;
      font-size: 20px;
      width: 20%;
    }

  .card-object:not(:hover) .management {
    display: none;
  }

  .management button:hover, .management a:hover {
    font-size: 22px;
  }
  .card .body-card {
    height: 40%;
    width: 100%;
  }


  .v-enter-active,
  .v-leave-active {
    transition: opacity 0.5s ease;
  }

  .v-enter-from,
  .v-leave-to {
    opacity: 0;
  }


</style>




// WEBPACK FOOTER //
// src/pages/Adherent/CmsGestion.vue